function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import DragM from 'dragm'; // import classNames from 'classnames';

import PropTypes from 'prop-types';
import Modal from '../modal';
import Button from '../button';
import Icon from '../icon';
var prefixCls = 'eui-dialog';

var Dialog = /*#__PURE__*/function (_React$Component) {
  _inherits(Dialog, _React$Component);

  var _super = _createSuper(Dialog);

  function Dialog() {
    var _this;

    _classCallCheck(this, Dialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      visible: _this.props.visible || false
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      _this.setState({
        visible: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClose", function (e) {
      _this.setState({
        visible: false
      });

      var handleClose = _this.props.handleClose;

      if (handleClose) {
        handleClose.call(_assertThisInitialized(_this), e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (e) {
      _this.setState({
        visible: false
      });

      var handleCancel = _this.props.handleCancel;

      if (handleCancel) {
        handleCancel.call(_assertThisInitialized(_this), e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onConfirm", function (e) {
      _this.setState({
        visible: false
      });

      var handleOk = _this.props.handleOk;

      if (handleOk) {
        handleOk.call(_assertThisInitialized(_this), e);
      }
    });

    return _this;
  }

  _createClass(Dialog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          visible = _this$props.visible,
          title = _this$props.title,
          maskClosable = _this$props.maskClosable,
          mask = _this$props.mask,
          confirmText = _this$props.confirmText,
          cancelText = _this$props.cancelText,
          className = _this$props.className,
          handleClose = _this$props.handleClose,
          renderInline = _this$props.renderInline,
          dragm = _this$props.dragm,
          onClick = _this$props.onClick;
      var content = /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, " ").concat(className || ''),
        style: {
          display: visible ? 'block' : 'none'
        }
      }, title ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-hd")
      }, /*#__PURE__*/React.createElement("h3", {
        className: "".concat(prefixCls, "-hd-title")
      }, title)) : '', /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-bd")
      }, children), cancelText || confirmText ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-ft")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-ft-ctrls")
      }, cancelText ? /*#__PURE__*/React.createElement(Button, {
        onClick: this.onCancel,
        size: "medium",
        type: "default",
        className: "".concat(prefixCls, "-btncancle"),
        text: cancelText
      }) : '', confirmText ? /*#__PURE__*/React.createElement(Button, {
        onClick: this.onConfirm,
        size: "medium",
        type: "primary",
        className: "".concat(prefixCls, "-btnok"),
        text: confirmText
      }) : '')) : '', handleClose ? /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "".concat(prefixCls, "-close"),
        onClick: this.onClose
      }, /*#__PURE__*/React.createElement(Icon, {
        value: "delete"
      })) : null);
      return /*#__PURE__*/React.createElement(Modal, {
        visible: visible,
        maskClosable: maskClosable,
        mask: mask,
        handleClose: this.onClose,
        renderInline: renderInline,
        className: "".concat(className ? "".concat(className, "-modal") : ''),
        onClick: onClick
      }, dragm ? /*#__PURE__*/React.createElement(DragM, null, content) : content);
    }
  }]);

  return Dialog;
}(React.Component);

_defineProperty(Dialog, "defaultProps", {
  title: undefined,
  confirmText: '确认',
  cancelText: '取消',
  mask: true,
  handleOk: function handleOk() {},
  handleClose: null,
  handleCancel: function handleCancel() {},
  maskClosable: true,
  renderInline: false,
  dragm: false
});

_defineProperty(Dialog, "propTypes", {
  visible: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func,
  handleOk: PropTypes.func,
  handleClose: PropTypes.func,
  maskClosable: PropTypes.bool,
  // mask是否可以点击关闭
  mask: PropTypes.bool,
  // 是否显示mask
  title: PropTypes.string,
  // 标题
  confirmText: PropTypes.string,
  // 确认文案
  cancelText: PropTypes.string,
  // 取消文案
  renderInline: PropTypes.bool,
  // 是否插到body底下:false为是，true为当前节点
  dragm: PropTypes.bool // 是否可拖动

});

export default Dialog;